import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ExposeGrid from './components/ExposeGrid';
import CategoryNav from './components/CategoryNav';
import HotRankings from './components/HotRankings';
import TrackingSection from './components/TrackingSection';
import SubscribeCTA from './components/SubscribeCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <ExposeGrid />
        <CategoryNav />
        <HotRankings />
        <TrackingSection />
        <SubscribeCTA />
      </main>
      <Footer />
    </div>
  );
}